// extracted by mini-css-extract-plugin
module.exports = {"zielecontainer":"DieZiele_zielecontainer__3kMFn"};